/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunitiesPerFreelancerFamilyResponse
 */
export interface OpportunitiesPerFreelancerFamilyResponse {
    /**
     * 
     * @type {string}
     * @memberof OpportunitiesPerFreelancerFamilyResponse
     */
    family: string;
    /**
     * 
     * @type {number}
     * @memberof OpportunitiesPerFreelancerFamilyResponse
     */
    conversionRate: number;
    /**
     * 
     * @type {number}
     * @memberof OpportunitiesPerFreelancerFamilyResponse
     */
    opportunitiesCount: number;
}

/**
 * Check if a given object implements the OpportunitiesPerFreelancerFamilyResponse interface.
 */
export function instanceOfOpportunitiesPerFreelancerFamilyResponse(value: object): value is OpportunitiesPerFreelancerFamilyResponse {
    if (!('family' in value) || value['family'] === undefined) return false;
    if (!('conversionRate' in value) || value['conversionRate'] === undefined) return false;
    if (!('opportunitiesCount' in value) || value['opportunitiesCount'] === undefined) return false;
    return true;
}

export function OpportunitiesPerFreelancerFamilyResponseFromJSON(json: any): OpportunitiesPerFreelancerFamilyResponse {
    return OpportunitiesPerFreelancerFamilyResponseFromJSONTyped(json, false);
}

export function OpportunitiesPerFreelancerFamilyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunitiesPerFreelancerFamilyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'family': json['family'],
        'conversionRate': json['conversionRate'],
        'opportunitiesCount': json['opportunitiesCount'],
    };
}

export function OpportunitiesPerFreelancerFamilyResponseToJSON(value?: OpportunitiesPerFreelancerFamilyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'family': value['family'],
        'conversionRate': value['conversionRate'],
        'opportunitiesCount': value['opportunitiesCount'],
    };
}

